import { AppState } from "../app.state";

export const getLastFetchedDate = (state: AppState) => state.sauen.lastFetched;

export const getSauenStatus = (state: AppState) => state.sauen.loadStatus;

export const getSauen = (state: AppState) => state.sauen.sauen;
